import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { finalize } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { GenerateTicketModalComponent } from '../../ticketing/generate-ticket-modal/generate-ticket-modal.component';
import { TaxpayerModalComponent } from '../taxpayer-modal/taxpayer-modal.component';
import { AuthService } from 'src/app/services/auth/auth.service';
import { IgrAssessmentAsinVerificationModalComponent } from '../../igr-services/igr-assessment/igr-assessment-asin-verification-modal/igr-assessment-asin-verification-modal.component';
import { IgrAssessmentApplicationModalComponent } from '../../igr-services/igr-assessment/igr-assessment-application-modal/igr-assessment-application-modal.component';

enum View {
  PROFILED = 'PROFILED',
  UNPROFILED = 'UNPROFILED',
  ALL = 'ALL'
}

@Component({
  selector: 'app-taxpayer-landing',
  standalone: false,
  templateUrl: './taxpayer-landing.component.html',
  styleUrl: './taxpayer-landing.component.scss'
})
export class TaxpayerLandingComponent {
  action_idx: any = null;



  activeTab: View;
  View = View;

  ticketList: any[] = [];
  searchForm!: FormGroup;

  isSearching: boolean = false;
  showSearchForm: boolean = false;

  searchedTicketNotFound = false;
  isEmpty!: boolean;
  searched = false;
  isLoading: boolean = false;

  selectedStatus!: boolean;

  isDarkMode!: boolean;

  page: number = 0;
  num: number = 1;
  currentPage: number = 1;
  count: number = 0;
  pageSize: number = 10;
  selectedLimit: number = 10;

  @Output() onConfirmClicked = new EventEmitter();
  vehicleTypes: any[] = [];

  toggleShowSearch() {
    this.showSearchForm = !this.showSearchForm;
  }


  clearSearchFilters() {
    this.searchForm.reset()
  }

  constructor(
    public fb: FormBuilder,
    private apiService: ApiService,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.searchForm = this.fb.group({
      name: [''],
      asin: [''],
      phone: [''],
      email: [''],
      from: [''],
      to: [''],
      offset: [''],
    });

    this.getAllVehicleTypes()

    const snapshot = this.route.snapshot;
    this.activeTab = snapshot.queryParams['tab'] ? snapshot.queryParams['tab'] as View : View.UNPROFILED;

    this.search();
  }

  setIsActive(tab: any) {

    this.activeTab = tab;

    this.search()

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { tab },
      queryParamsHandling: 'merge',
    });
  }

  getAllVehicleTypes() {
    this.isLoading = true;
    this.apiService
      .get('/vehicle-type/all')
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response: any) => {
        this.vehicleTypes = response.data.map((vehicleType) => ({
          ...vehicleType,
          formattedName: this.toTitleCase(vehicleType.name.replace(/_/g, ' ')),
        }));
      });
  }

  toTitleCase(str: string): string {
    return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  }


  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  callDb(event: any) {
    this.currentPage = event;

    this.page = event - 1;

    this.search();
  }

  updateLimit() {
    this.currentPage = 1;

    this.page = 0;

    this.search();
  }

  search() {
    this.ticketList = [];
    this.searchedTicketNotFound = false;
    this.isSearching = true;

    this.pageSize = this.selectedLimit;

    this.num = this.page * this.selectedLimit;

    const searchFormValues = this.searchForm?.value
    var formData: any = new FormData();

    formData.append('offset', this.num);
    formData.append('limit', this.selectedLimit);
    formData.append("from", this.searchForm.get('from')?.value || '');
    formData.append("to", this.searchForm.get('to')?.value || '');

    formData.append("name", this.searchForm.get('name')?.value || '');
    formData.append("email", this.searchForm.get('email')?.value || '');
    formData.append("asin", this.searchForm.get('asin')?.value || '');
    formData.append("phoneNumber", this.searchForm.get('phone')?.value || '');

    if (this.activeTab !== View.ALL) {
      formData.append("profilingStatus", this.activeTab || '');
    }

    this.apiService
      .post('/taxpayer/page', formData)
      .pipe(
        finalize(() => {
          this.isSearching = false;
          this.isLoading = false;
        })
      )
      .subscribe(
        (response) => {
          this.ticketList = response.data;
          // this.openTaxpayerModal(response.data[0], true)
          this.count = response.totalElements;

          if (this.count == 0) {
            this.searchedTicketNotFound = true;
          }
        },
        (error) => {
          this.openErrorModal(error?.message);
          this.searchedTicketNotFound = true;
        }
      );
  }

  hasAccess(permissions: string[]) {
    return this.authService.hasAnyPermission(permissions)
  }

  openDialogRef(data?: any) {
    let dialogRef = this.dialog.open(GenerateTicketModalComponent, {
      width: '450px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form'],
      disableClose: true,

      data,
    });

    return dialogRef;
  }




  openTaxpayerModal(data: any, isInEditingMode = false) {
    return this.dialog.open(TaxpayerModalComponent, {
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'custom-dialog-xl',],
      disableClose: true,
      data: isInEditingMode ? { ...data, isInEditingMode: true } : data,
    });
  }

  verifyAssessmentAsin(data: any) {
    const dialogRef = this.dialog.open(IgrAssessmentAsinVerificationModalComponent, {
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'custom-dialog-md'],
      disableClose: true,
      data: { asin: data.asin },
    });

    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        this.createAssessment(data)
      }
    })
  }

  createAssessment(data: any) {
    let dialogRef = this.dialog.open(IgrAssessmentApplicationModalComponent, {
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'custom-dialog-xl'],
      disableClose: true,

      data: data,
    });


    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.router.navigate(['/admin/igr-assessment']);
      }
    });
  }

  generateNewTickets() {
    this.openDialogRef();
  }
}
